<template>
    <div class="nodata-box">
        <img src="@/assets/wu.png"/>
        <span class="nodata-text">暂无数据</span>
    </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    created(){

    },
    methods:{

    },

}
</script>

<style lang="scss" scoped>
.nodata-box{
    display: flex;
    margin-top:30px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    >img{
        width: 50px;
        height: 50px;
    }
    .nodata-text{
        color: #b2b6b9;
        text-indent: 0;
    }
}
</style>